import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {User} from '../model';
import {UserProvider} from '../providers';
import * as _ from 'lodash';
import {Router} from '@angular/router';
import {OrganizationType} from '../model/Enums';
import {BusinessType} from '../model/enums/business.type';

@Injectable()
export class UserService {
  user = new BehaviorSubject<User>(null);
  user$ = this.user.asObservable();

  reportLockForDashboard = new BehaviorSubject<any>(null);

  loginDetails: any = null;
  isApiCalling: boolean = false;

  constructor(private userProvider: UserProvider,
    private router: Router) {
    this.loginDetails = JSON.parse(localStorage.getItem('IV-PROFILE'));
    if (this.loginDetails) {
      this.getUserProfile();
    }
  }

  public setUser(newUser: User): void {
    this.user.next(newUser);
    localStorage.setItem('IV-PROFILE', JSON.stringify(newUser));
  }

  public clearUser(): void {
    this.user.next(null);
  }

  public getUserProfile(): void {
    if (!this.isApiCalling) {
      this.isApiCalling = true;
      this.userProvider.getMyProfile()
        .subscribe(data => {
          this.isApiCalling = false;
          if (data.success) {
            const u = User.parse(data.result);
            if (u.FORCE_PASS_RESET) {
              this.router.navigateByUrl('/login');
            } else {
              this.setUser(u);
            }
          }
        });
    }
  }

  getProfileAwait(): Promise<boolean> {
    return new Promise((resolve) => {
      this.userProvider.getMyProfile()
        .subscribe(data => {
          if (data.success) {
            const u = User.parse(data.result);
            this.setUser(u);
            resolve(true);
          } else {
            resolve(false);
          }
        }, (err) => {
          resolve(false);
        });
    });
  }

  getUserId() {
    return this.user.getValue().ID;
  }

  getUserFirstName() {
    return this.user?.getValue()?.NAME_FIRST;
  }

  getUserFullName() {
    return this.user?.getValue()?.NAME_FIRST + ' ' + this.user?.getValue()?.NAME_LAST;
  }

  setUserFirstName(name: string) {
    this.user.getValue().NAME_FIRST = name;
  }

  checkAdminRole(): boolean {
    if (this.user?.getValue()?.USER_ROLES && this.user?.getValue().USER_ROLES.find(el => el.CODE == 'ROLE_ADMIN')) {
      return true;
    } else {
      return false;
    }
  }

  checkOrganizationAdmin(): boolean {
    if (this.user?.getValue()?.USER_ROLES && this.user?.getValue().USER_ROLES.find(el => el.CODE == 'ROLE_ORG_ADMIN')) {
      return true;
    } else {
      return false;
    }
  }

  isOrganizationUser(): boolean {
    if (this.user?.getValue()?.ORGANIZATION?.ID) {
      return true;
    } else {
      return false;
    }
  }

  isOrganizationType_BANK(): boolean {
    if (this.isOrganizationUser()) {
      return this.user?.getValue()?.ORGANIZATION?.ORGANIZATION_TYPE === OrganizationType.BANK ||
        this.user?.getValue()?.ORGANIZATION?.ORGANIZATION_TYPE === OrganizationType.SBDC;
    } else {
      return false;
    }
  }

  getOrganizationId() {
    return this.getCurrentUser()?.ORGANIZATION?.ID || '';
  }

  getOrganizationName() {
    return this.user?.getValue()?.ORGANIZATION?.NAME || '';
  }

  getUserCompanyName() {
    return this.user?.getValue()?.COMPANY || '';
  }

  getUser(): User {
    return this.user.getValue();
  }

  getCurrentUser(): User {
    if (!this.user.getValue()) {
      this.getUserProfile();
    }
    return this.user.getValue();
  }

  wsMessageReceived(message: any): void {
    if (message && _.isArray(message)) {
      for (let i = 0; i < message.length; i++) {
        const element = message[i];
        if (element && element.ID === this.getUserId()) {
          if (element.FIELD === 'CREDITS') {
            this.user.getValue().CREDITS = element.VALUE;
          }
        } else if (element && element.GROUP == 'REPORT_LOCKING' && element.VALUE) {
          this.reportLockForDashboard.next(element.VALUE);
        }
      }
    }

  }

  getUserCredits() {
    return this.user?.getValue()?.CREDITS || 0;
  }

  get isBrokerUser(): boolean {
    return this.user?.getValue()?.BUSINESS_TYPE === BusinessType.BROKER;
  }

  get isPremiumUser(): boolean {
    return this.user?.getValue()?.PREMIUM;
  }

  setUserPremium(status: boolean) {
    this.user.getValue().PREMIUM = status;
  }

  get isOrganizationType_SBDC(): boolean {
    if (this.isOrganizationUser()) {
      return this.user?.getValue()?.ORGANIZATION?.ORGANIZATION_TYPE === OrganizationType.SBDC;
    } else {
      return false;
    }
  }

  get isUserType_SBDC(): boolean {
    return this.user?.getValue()?.BUSINESS_TYPE === BusinessType.SBDC;
  }
}
